import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'
import { themeColors } from '../../styles/theme'

const PrivacyPolicy = () => (
  <Paper style={styles.paper}>
    <h4 style={styles.titles}>Privacy Policy</h4>
    <h6 style={styles.subtitles}>
      Trattamento dei dati personali
    </h6>
    <p>
      Titolare del trattamento dei dati è Wegreen S.r.l., corrente in Via del Casalino, 13 – 24121 Bergamo (Italia).
    </p>
    <p>
      Ai sensi DELL' ART. 13 DEL D.lgs. 196/2003, la Società utilizzerà i dati personali dell’utente al fine di:
    </p>
    <ul>
      <li>fornire i servizi offerti dal Sito;</li>
      <li>inviare messaggi informativi e/o newsletter;</li>
      <li>
        risalire ad autori di eventuali illeciti solo in caso di specifiche richieste e per conto delle autorità competenti.
      </li>
    </ul>
    <p>
      Il conferimento dei dati è facoltativo, ma in loro assenza non sarà possibile fornire il servizio in questione.
    </p>
    <p>
      Attraverso la registrazione l'utente acconsente ad inserire i propri dati per l'esecuzione dei servizi, in particolare sono richiesti nome utente, email, password e provincia di residenza.
    </p>
    <p>
      Attraverso la registrazione con Facebook il servizio chiede all'utente di acconsentire, tramite apposita schermata di autorizzazione, alla lettura di alcune informazioni personali relative all'utente e di effettuare interazioni al suo posto all'interno del social network. Dopo l'autorizzazione dell'utente il Sito potrà ottenere informazioni su Nome, Cognome, Email, User Location, User Hometown e Offline Access e pubblicare sulla bacheca dell'utente. Per maggiorni informazioni sulle Privacy Policy di Facebook Inc. si prega di consultare il link
      {' '}
      <a
        href="http://www.facebook.com/about/privacy/"
        rel="noopener noreferrer"
        target="_blank">
        http://www.facebook.com/about/privacy/
      </a>
      .
    </p>
    <p>
      I dati personali dell’utente saranno inseriti in un archivio cartaceo e/o informatico, custoditi secondo la vigente normativa, con accesso esclusivo della Società.
    </p>
    <p>
      Se ritenuto indispensabile al fine di fornire un adeguato servizio e per la gestione e conservazione degli stessi, i dati potranno essere comunicati dalla Società a terzi.
    </p>
    <p>
      La Società non controllerà, modificherà o divulgherà il contenuto delle comunicazioni private dell'utente. Tuttavia la Società si riserva di intervenire, nel modo sopra descritto, sulle predette informazioni, qualora ritenga, secondo buona fede, tale attività necessaria per adempiere ad obblighi normativi o per adeguarsi ad un provvedimento dell'Autorità Giudiziaria o di altra Autorità competente. Inoltre, le suddette informazioni possono essere utilizzate nel modo più ampio per difendersi da contestazioni di terzi e per tutelare gli interessi della Società.
    </p>
    <p>
      Nel Sito web swapick.com vengono utilizzati "cookie" al solo fine di migliorare l'organizzazione del Sito stesso e offrire un migliore accesso ai visitatori.
    </p>
    <p>
      Il Sito contiene strumenti per l'esclusione dei sistemi automatici dei motori di ricerca per la tutela dei dati personali degli utenti.
    </p>
    <p>
      L’Utente può richiedere in ogni momento, ai sensi dell'art. 7 del D.lgs 196/2003, che i suddetti dati siano messi a disposizione, per la loro verifica, cancellazione o modifica inviando una segnalazione tramite il pulsante "
      <strong style={{ color: themeColors.positive }}>
        Aiuto
      </strong>
      " visibile in basso a destra sulla pagina
      {' '}
      <i>"Come funziona"</i>
      {' '}
      e sulla homepage.
    </p>
  </Paper>
)

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/common/Infotext/PrivacyPolicy.js